import { trace } from 'rytm-helpers'
import SoundBankController from './SoundBankController'

class SoundController {
  /**
  * SoundController class constructor  
  * @constructor
  **/
  constructor() {
    this.banks = []
    this.currentBank = false
  }
  initSounds() {
    this.banks = []
    this.currentBank = false
    if (window.__wa_soundbanks) {
      this._addSoundBanks(window.__wa_soundbanks)
    }
  }
  play(sndBankId) {
    this.currentBank = this._getSoundBank(sndBankId)
    trace("Play sound bank:", sndBankId, this.currentBank)
    if (this.currentBank) {
      this.currentBank.playSound("loop", {loop: true})
    }
  }
  getSoundFrequencyData(sndId) {
    return this.currentBank ? this.currentBank.getSoundFrequencyData(sndId) : null
  }
  /**
   * Add sound banks
   * @param {Array} files 
   * @param {String} path 
   */
  _addSoundBanks(sndBanks) {
    sndBanks.forEach((sndObj) => {
      let sbc = new SoundBankController()
      sbc.addSoundBank(sndObj)
      switch (sbc.id) {
        default:
          this.banks.push(sbc)
          break;
      }
    })
  }
  /**
   * Destroy sound bank
   */
  destroySoundBanks() {
    this.banks.forEach((bank) => {
      bank.destroySoundBank()
    })
    if (this.musicBank) {
      this.musicBank.destroySoundBank()
    }
    this.musicBank = false
    this.banks = []
    if (this._bgSound) {
      this._bgSound.stop()
      this._bgSound = null
    }
  }
  /**
   * Stop all sounds
   */
  stopAllSounds() {
    this.banks.forEach((bank) => {
      bank.stopAllSounds()
    })
    if (this.musicBank) {
      this.musicBank.stopAllSounds()
    }
    if (this._bgSound) {
      this._bgSound.stop()
    }
  }

  _getSoundBank(sndBankId) {
    let result = null
    this.banks.forEach((bank) => {
      if (bank.id == sndBankId) {
        result = bank
        return result
      }
    })
    return result
  }


}

const soundController = new SoundController()
export default soundController